{
  "v": "5.5.10",
  "fr": 30,
  "ip": 0,
  "op": 81,
  "w": 160,
  "h": 100,
  "nm": "コンポ 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Ear_R",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] },
            { "t": 80, "s": [360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [119.25, 62.75, 0], "ix": 2 },
        "a": { "a": 0, "k": [5, 8, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -0.275],
                    [0, 0],
                    [-0.275, 0],
                    [0, 0],
                    [0, 0.275],
                    [0, 0],
                    [0.275, 0]
                  ],
                  "o": [
                    [-0.275, 0],
                    [0, 0],
                    [0, 0.275],
                    [0, 0],
                    [0.275, 0],
                    [0, 0],
                    [0, -0.275],
                    [0, 0]
                  ],
                  "v": [
                    [-1, -4.5],
                    [-1.5, -4],
                    [-1.5, 4],
                    [-1, 4.5],
                    [1, 4.5],
                    [1.5, 4],
                    [1.5, -4],
                    [1, -4.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.93, 0],
                    [0, 0],
                    [0, 1.93],
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, -1.93],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, -1.93],
                    [0, 0],
                    [1.93, 0],
                    [0, 0],
                    [0, 1.93]
                  ],
                  "v": [
                    [1, 7.5],
                    [-1, 7.5],
                    [-4.5, 4],
                    [-4.5, -4],
                    [-1, -7.5],
                    [1, -7.5],
                    [4.5, -4],
                    [4.5, 4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [4.75, 7.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -1.104],
                    [0, 0],
                    [1.104, 0],
                    [0, 0],
                    [0, 1.104],
                    [0, 0],
                    [-1.105, 0]
                  ],
                  "o": [
                    [1.104, 0],
                    [0, 0],
                    [0, 1.104],
                    [0, 0],
                    [-1.105, 0],
                    [0, 0],
                    [0, -1.104],
                    [0, 0]
                  ],
                  "v": [
                    [1, -6],
                    [3, -4],
                    [3, 4],
                    [1, 6],
                    [-1, 6],
                    [-3, 4],
                    [-3, -4],
                    [-1, -6]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [4.751, 7.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": -1,
      "op": 81,
      "st": -1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Ear_L",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [0] },
            { "t": 80, "s": [-360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [41.25, 62.75, 0], "ix": 2 },
        "a": { "a": 0, "k": [5, 8, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -0.275],
                    [0, 0],
                    [-0.275, 0],
                    [0, 0],
                    [0, 0.275],
                    [0, 0],
                    [0.275, 0]
                  ],
                  "o": [
                    [-0.275, 0],
                    [0, 0],
                    [0, 0.275],
                    [0, 0],
                    [0.275, 0],
                    [0, 0],
                    [0, -0.275],
                    [0, 0]
                  ],
                  "v": [
                    [-1, -4.5],
                    [-1.5, -4],
                    [-1.5, 4],
                    [-1, 4.5],
                    [1, 4.5],
                    [1.5, 4],
                    [1.5, -4],
                    [1, -4.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.93, 0],
                    [0, 0],
                    [0, 1.93],
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, -1.93],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, -1.93],
                    [0, 0],
                    [1.93, 0],
                    [0, 0],
                    [0, 1.93]
                  ],
                  "v": [
                    [1, 7.5],
                    [-1, 7.5],
                    [-4.5, 4],
                    [-4.5, -4],
                    [-1, -7.5],
                    [1, -7.5],
                    [4.5, -4],
                    [4.5, 4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [4.75, 7.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -1.104],
                    [0, 0],
                    [1.104, 0],
                    [0, 0],
                    [0, 1.104],
                    [0, 0],
                    [-1.105, 0]
                  ],
                  "o": [
                    [1.104, 0],
                    [0, 0],
                    [0, 1.104],
                    [0, 0],
                    [-1.105, 0],
                    [0, 0],
                    [0, -1.104],
                    [0, 0]
                  ],
                  "v": [
                    [1, -6],
                    [3, -4],
                    [3, 4],
                    [1, 6],
                    [-1, 6],
                    [-3, 4],
                    [-3, -4],
                    [-1, -6]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [4.75, 7.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": -1,
      "op": 81,
      "st": -1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Head",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 0,
              "s": [80.25, 22.75, 0],
              "to": [0, -1.667, 0],
              "ti": [0, -0.333, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 9,
              "s": [80.25, 12.75, 0],
              "to": [0, 0.333, 0],
              "ti": [0, -1.333, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 16,
              "s": [80.25, 24.75, 0],
              "to": [0, 1.333, 0],
              "ti": [0, 0.333, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 20,
              "s": [80.25, 20.75, 0],
              "to": [0, -0.333, 0],
              "ti": [0, -0.333, 0]
            },
            { "t": 23, "s": [80.25, 22.75, 0] }
          ],
          "ix": 2
        },
        "a": { "a": 0, "k": [10, 10, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 0,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 9,
              "s": [100, 110, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 16,
              "s": [110, 90, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 20,
              "s": [100, 105, 100]
            },
            { "t": 23, "s": [100, 100, 100] }
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [3.584, 0],
                    [0, -3.584],
                    [-3.584, 0],
                    [0, 3.584]
                  ],
                  "o": [
                    [-3.584, 0],
                    [0, 3.584],
                    [3.584, 0],
                    [0, -3.584]
                  ],
                  "v": [
                    [0, -6.5],
                    [-6.5, 0],
                    [0, 6.5],
                    [6.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.238, 0],
                    [0, 5.238],
                    [-5.238, 0],
                    [0, -5.238]
                  ],
                  "o": [
                    [-5.238, 0],
                    [0, -5.238],
                    [5.238, 0],
                    [0, 5.238]
                  ],
                  "v": [
                    [0, 9.5],
                    [-9.5, 0],
                    [0, -9.5],
                    [9.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [9.75, 9.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.418, 0],
                    [0, -4.418],
                    [4.418, 0],
                    [0, 4.418]
                  ],
                  "o": [
                    [4.418, 0],
                    [0, 4.418],
                    [-4.418, 0],
                    [0, -4.418]
                  ],
                  "v": [
                    [0, -8],
                    [8, 0],
                    [0, 8],
                    [-8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [9.751, 9.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": -1,
      "op": 81,
      "st": -1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Face",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [80.25, 62.75, 0], "ix": 2 },
        "a": { "a": 0, "k": [32, 28, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.275, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, -0.275]
                  ],
                  "o": [
                    [0, 0.275],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.275, 0],
                    [0, 0]
                  ],
                  "v": [
                    [16.5, 4],
                    [16, 4.5],
                    [10.5, 4.5],
                    [10.5, -4.5],
                    [16, -4.5],
                    [16.5, -4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0.275],
                    [0, 0],
                    [-0.275, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -0.275],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.275, 0]
                  ],
                  "v": [
                    [-16.5, 4],
                    [-16.5, -4],
                    [-16, -4.5],
                    [-10.5, -4.5],
                    [-10.5, 4.5],
                    [-16, 4.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.5, 4.5],
                    [-7.5, 4.5],
                    [-7.5, -4.5],
                    [-1.5, -4.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.5, -4.5],
                    [7.5, -4.5],
                    [7.5, 4.5],
                    [1.5, 4.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.93, 0],
                    [0, 0],
                    [0, -1.93],
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, 1.93],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.93, 0],
                    [0, 0],
                    [0, 1.93],
                    [0, 0],
                    [1.93, 0],
                    [0, 0],
                    [0, -1.93]
                  ],
                  "v": [
                    [16, -7.5],
                    [-16, -7.5],
                    [-19.5, -4],
                    [-19.5, 4],
                    [-16, 7.5],
                    [16, 7.5],
                    [19.5, 4],
                    [19.5, -4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [31.75, 40.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 1",
          "np": 7,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [3.584, 0],
                    [0, -3.584],
                    [-3.584, 0],
                    [0, 3.584]
                  ],
                  "o": [
                    [-3.584, 0],
                    [0, 3.584],
                    [3.584, 0],
                    [0, -3.584]
                  ],
                  "v": [
                    [0, -6.5],
                    [-6.5, 0],
                    [0, 6.5],
                    [6.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.238, 0],
                    [0, 5.238],
                    [-5.238, 0],
                    [0, -5.238]
                  ],
                  "o": [
                    [-5.238, 0],
                    [0, -5.238],
                    [5.238, 0],
                    [0, 5.238]
                  ],
                  "v": [
                    [0, 9.5],
                    [-9.5, 0],
                    [0, -9.5],
                    [9.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [43.75, 20.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 2",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [3.584, 0],
                    [0, -3.584],
                    [-3.584, 0],
                    [0, 3.584]
                  ],
                  "o": [
                    [-3.584, 0],
                    [0, 3.584],
                    [3.584, 0],
                    [0, -3.584]
                  ],
                  "v": [
                    [0, -6.5],
                    [-6.5, 0],
                    [0, 6.5],
                    [6.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.238, 0],
                    [0, 5.238],
                    [-5.238, 0],
                    [0, -5.238]
                  ],
                  "o": [
                    [-5.238, 0],
                    [0, -5.238],
                    [5.238, 0],
                    [0, 5.238]
                  ],
                  "v": [
                    [0, 9.5],
                    [-9.5, 0],
                    [0, -9.5],
                    [9.5, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [19.75, 20.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [3.584, 0],
                    [0, 0],
                    [0, 3.584],
                    [0, 0],
                    [-3.584, 0],
                    [0, 0],
                    [0, -3.584]
                  ],
                  "o": [
                    [0, 3.584],
                    [0, 0],
                    [-3.584, 0],
                    [0, 0],
                    [0, -3.584],
                    [0, 0],
                    [3.584, 0],
                    [0, 0]
                  ],
                  "v": [
                    [28.5, 18],
                    [22, 24.5],
                    [-22, 24.5],
                    [-28.5, 18],
                    [-28.5, -18],
                    [-22, -24.5],
                    [22, -24.5],
                    [28.5, -18]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [5.238, 0],
                    [0, 0],
                    [0, -5.238],
                    [0, 0],
                    [-5.238, 0],
                    [0, 0],
                    [0, 5.238],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-5.238, 0],
                    [0, 0],
                    [0, 5.238],
                    [0, 0],
                    [5.238, 0],
                    [0, 0],
                    [0, -5.238]
                  ],
                  "v": [
                    [22, -27.5],
                    [-22, -27.5],
                    [-31.5, -18],
                    [-31.5, 18],
                    [-22, 27.5],
                    [22, 27.5],
                    [31.5, 18],
                    [31.5, -18]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "パスを結合 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.552999997606, 0.368999974868, 0.2, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [31.75, 27.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -4.418],
                    [0, 0],
                    [4.418, 0],
                    [0, 0],
                    [0, 4.418],
                    [0, 0],
                    [-4.418, 0]
                  ],
                  "o": [
                    [4.418, 0],
                    [0, 0],
                    [0, 4.418],
                    [0, 0],
                    [-4.418, 0],
                    [0, 0],
                    [0, -4.418],
                    [0, 0]
                  ],
                  "v": [
                    [22, -26],
                    [30, -18],
                    [30, 18],
                    [22, 26],
                    [-22, 26],
                    [-30, 18],
                    [-30, -18],
                    [-22, -26]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "パス 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "塗り 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [31.751, 27.75], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "トランスフォーム"
            }
          ],
          "nm": "グループ 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": -1,
      "op": 81,
      "st": -1,
      "bm": 0
    }
  ],
  "markers": []
}
